<template>
  <div class="FlowRate" ref="section">
    <div
      class="FlowRate-animation"
      :class="{ 'animation-triggered': videoVisible }"
    >
      <video
        v-show="videoVisible"
        :src="videoSrc"
        class="flowrate-video"
        playsinline
        preload="auto"
        autoplay
        muted
        loop
        :key="videoSrc"
        @ended="onVideoEnded"
      ></video>

    </div>
    <h1 class="FlowRate-title">
      <span class="gradient animate-line delay-2">
         <div v-html="$t('TskSelectNeedle.FlowRate1')"></div>
      </span>
      <span class="line-1 animate-line delay-1">
        <div v-html="$t('TskSelectNeedle.FlowRate2')"></div>
      </span>
    </h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoVisible: false,
      hasPlayed: false,
      isMobile: false,
    }
  },
  computed: {
    assetBase() {
      return (process.env.VUE_APP_ARTICLE_BASE_URL || '').replace(/\/$/, '')
    },
    videoSrc() {
      return this.isMobile
        ? `${this.assetBase}/mp4/TSN/FlowRate/FlowRate_phone.mp4`
        : `${this.assetBase}/mp4/TSN/FlowRate/FlowRate.mp4`
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener("resize", this.checkDevice)
    window.addEventListener("orientationchange", this.checkDevice)

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0 && !this.hasPlayed) {
          this.videoVisible = true
          this.hasPlayed = true
          this.$nextTick(() => {
            const video = this.$el.querySelector('video')
            if (video && video.paused) {
              video.play().catch(() => {})
            }
            observer.disconnect()
          })
        }
      },
      { threshold: [0, 0.33, 0.66, 1] }
    )
    observer.observe(this.$refs.section)
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkDevice)
    window.removeEventListener("orientationchange", this.checkDevice)
  },
  methods: {
    checkDevice() {
      const isPortrait = window.innerHeight > window.innerWidth
      const ua = navigator.userAgent
      const isiPad = /iPad/.test(ua) || (ua.includes("Macintosh") && 'ontouchend' in document)
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

      this.isMobile = isPortrait && (window.innerWidth <= 820 || isiPad || isTouchDevice)
    },
    onVideoEnded() {
      // this.videoVisible = false
    }
  }
}
</script>

<style scoped>
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.FlowRate {
/* removed min-height */
/* removed flex */
/* removed justify-content */
/* removed align-items */
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.FlowRate-animation {
  opacity: 0;
  transition: opacity 0.8s ease;
}
.FlowRate-animation.animation-triggered {
  opacity: 1;
}
.flowrate-video {
  width: 100vw;
  /* max-height removed */
  height: auto;
  display: block;
  background: #000;
  pointer-events: none;
  user-select: none;
}
.FlowRate-title {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  font-family: 'PingFang TC', 'Open Sans', 'Noto Sans TC', 'Heiti TC', sans-serif;
  font-size: clamp(1rem, 2vw, 2rem);
  text-align: center;
  line-height: 1.5;
  z-index: 10;
  max-width: 90vw;
  letter-spacing: 0.05em;
  padding: 0 0.1rem;
}
.line-1 {
  display: block;
  color: #FFF;
  font-weight: 350;
}
.gradient {
  background: linear-gradient(to bottom, #279EFF, #1ACAD2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 900;
  letter-spacing: 0.16em;
}
.animate-line {
  opacity: 0;
  animation: fadeUp 0.8s ease-out forwards;
}
.delay-1 {
  animation-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.6s;
}
</style>
